import {_} from 'lodash';
import Transform from "../Transform";
import {IExportFlow, IExportTemplate, IRouteDefinitionParams, ITableColumn} from '../../../../index';
import {nsFa} from "../../../fa/fn";
import {nsDynamicVariable} from "../../../dynamic-variable/nsDynamicVariable";
import {nsRoute} from "../../../../util/route";
import {memoryStore} from "../../../../util/memorystore";
import {DEFAULT_SEARCH_PAGE, DEFAULT_SORT_ORDER} from "../../../../constants";
import {getHash} from "../../../../constants/RouteDefinitions";
import i = nsFa.i;
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import ReadAbstractHtml from './ReadAbstract.html?raw';

interface IParams extends IRouteDefinitionParams {
    data: IExportFlow[]
    exportTemplate: IExportTemplate
}

export let template = ReadAbstractHtml;

export abstract class ReadAbstract extends ParsedRouteDataDecorator {
    private static LastId: number
    protected readonly abstract TableColumns: ITableColumn<IExportFlow>[];
    protected readonly data: IExportFlow[];
    protected readonly exportTemplate: IExportTemplate;
    private readonly asc: KnockoutObservable<boolean> = memoryStore.get(this.__routeId + '.searchascending', DEFAULT_SORT_ORDER)
    private readonly pagenr: KnockoutObservable<number> = memoryStore.get(this.__routeId + '.pagenr', DEFAULT_SEARCH_PAGE)
    private readonly sortcol: KnockoutObservable<string> = memoryStore.get(this.__routeId + '.searchcolumn', "id")

    constructor(params: IParams) {
        super(params)
        if (ReadAbstract.LastId != this.__id) {
            this.sortcol('id')
            this.pagenr(DEFAULT_SEARCH_PAGE)
            this.asc(DEFAULT_SORT_ORDER)
        }
        ReadAbstract.LastId = this.__id ?? 0
        this.data = params.data;
        this.exportTemplate = params.exportTemplate;
    }

    protected getCellContent(key: string, val: any, item: any): string | number | any[] | null {
        if (key == "expression" && val.indexOf("[TRANSFORM;") == 0 && nsDynamicVariable.validateExpression(val)) {
            return new Transform(val).getOutput();
        }

        switch (key) {
            case "$ruleset":
                return item.ruleset
                    ? `${i("fa-ruleset")} <a href="${getHash('rulesetdetails', {id: item.ruleset.id})}">${item.ruleset.name}</a>`
                    : null
                    ;
        }

        return this.getCellText(key, val, item);
    }

    protected getCellText(key: string, val: any, item: any): string | number | any[] | null {

        switch (key) {
            case "nullable":
                return !!val ? "Ja" : "Nei";
            case "$ruleset":
                return item.ruleset ? item.ruleset.name : null;
        }

        if (key.indexOf(".") > -1) {
            try {
                val = key.split('.').reduce((o: any, key: string) => o[key], item);
            } catch (err) {
            }
        }

        if (this.getTableColumn(key)?.count) {
            return val.length;
        }

        return _.isString(val)
            ? val.replace(/</g, '&lt;').replace(/>/g, '&gt;')
            : val
            ;
    }


    protected getTableColumn(key: string): ITableColumn<IExportFlow> | undefined {
        return  this.TableColumns.find((t: ITableColumn<IExportFlow>) => t.key == key);
    }

}
